const downloadContainer = document.createElement('div');
document.body.appendChild(downloadContainer);

const isChromeIos = () => navigator.userAgent.includes('CriOS');
const isFirefoxIos = () => navigator.userAgent.includes('FxiOS');

const downloadUrlIframe = (
  url: string,
  triggerDelay = 100,
  cleaningDelay = 1000 * 60 * 10,
): void => {
  // These browsers don't handle Content-Disposition header or <a download=""> attribute, so open the file instead
  // https://bugs.chromium.org/p/chromium/issues/detail?id=574033
  if (isChromeIos() || isFirefoxIos()) {
    const element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('target', '_blank');

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    return;
  }

  setTimeout(() => {
    const elem = document.createElement('iframe');
    elem.setAttribute('src', url);
    elem.style.display = 'none';
    downloadContainer.appendChild(elem);
    setTimeout(() => elem.remove(), cleaningDelay);
  }, triggerDelay);
};

export default downloadUrlIframe;
